<template>
  <form>
    <p v-if="error" class="error">{{ error }}</p>
    <div class="form-group row">
      <input
        v-model="form.email"
        type="email"
        id="email"
        class="form-control"
        :placeholder="$t('email')"
        debounce="500"
        :state="emailCheck"
        required
        autofocus
        @keyup.enter="resetPassword()"
      />
      <error-list :field="$v.form.email"></error-list>
    </div>
    <div class="form-group row">
      <router-link v-if="emailCheck" :to="{ name: 'passwordResetDone' }">
        <b-button
          id="login"
          class="float-left"
          icon="fa-envelope"
          :spinner="loading"
          :disabled="$v.form.$invalid"
          @click="resetPassword()"
        >
          {{ $t("resetPassword") }}
        </b-button>
      </router-link>
    </div>
  </form>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import AuthService from "@/services/AuthService";

export default {
  name: "PasswordResetForm",
  props: {},
  data() {
    return {
      form: {
        email: null
      },
      error: null,
      loading: false
    };
  },
  validations: {
    form: {
      email: {
        email,
        required
      }
    }
  },
  computed: {
    emailCheck() {
      return this.form.email && this.form.email.length > 3 && !this.$v.form.$invalid ? true : false;
    },
  },
  mounted() {},
  methods: {
    resetPassword() {
      this.loading = true;
      AuthService.resetPassword(this.form.email).then((response) => {
        this.loading--;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 50px auto auto auto;
}

.error {
  color: red;
}
</style>
